import { defineStore } from 'pinia'
import { useModal } from '@snowshoe-frontend/modal-component'

export const useModalStore = defineStore('modalStore', () => {
  const { modals, closeModal, createModal } = useModal()

  return {
    modals,

    closeModal,
    createModal
  }
})
